import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { VisitorAuthProvider } from "./context/VisitorAuthContext";
import { CookieConsent } from "./components/CookieConsent";
import Home from "./pages/Home";
import SubjectPage from "./pages/SubjectPage";
import FactPage from "./pages/FactPage";
import Favourites from "./pages/Favourites";
import Trivia from "./pages/Trivia";
import TriviaQuiz from "./pages/TriviaQuiz";
import TriviaArchive from "./pages/TriviaArchive";
import ChartNight from "./pages/ChartNight";
import { ScrollToTop } from "./components/ScrollToTop";
import TriviaChampions from "./pages/TriviaChampions";
import Club from "./pages/Club";
import Account from "./pages/Account";
import AdminTrivia from "./pages/AdminTrivia";
import AdminLogin from "./pages/AdminLogin";
import AdminNew from "./pages/AdminNew";
import AdminFacts from "./pages/AdminFacts";
import AdminCuriosWorkbench from "./pages/AdminCuriosWorkbench";
import AdminEditFact from "./pages/AdminEditFact";
import CopyrightPolicy from "./pages/CopyrightPolicy";
import AboutUs from "./pages/AboutUs";
import EditorialStandards from "./pages/EditorialStandards";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const RedirectToCurio = () => {
  const { slug } = useParams();
  return <Navigate to={`/curio/${slug}`} replace />;
};

const NOINDEX = [/^\/trivia\/play/, /^\/trivia\/archive/, /^\/favourites/, /^\/account/, /^\/club/, /^\/admin/];

const RobotsMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement("meta"); m.setAttribute("name", "robots"); document.head.appendChild(m); }
    m.setAttribute("content", NOINDEX.some((r) => r.test(pathname)) ? "noindex, follow" : "index, follow");
  }, [pathname]);
  return null;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <CookieConsent />
        <VisitorAuthProvider>
        <RobotsMeta />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/subject/:slug" element={<SubjectPage />} />
          <Route path="/curio/:slug" element={<FactPage />} />
          <Route path="/fact/:slug" element={<RedirectToCurio />} />
          <Route path="/favourites" element={<Favourites />} />
          <Route path="/trivia" element={<Trivia />} />
          <Route path="/trivia/play" element={<TriviaQuiz />} />
          <Route path="/trivia/archive" element={<TriviaArchive />} />
          <Route path="/trivia/chart-night" element={<ChartNight />} />
          <Route path="/trivia/sport-night" element={<ChartNight kind="sport" />} />
          <Route path="/trivia/champions" element={<TriviaChampions />} />
          <Route path="/club" element={<Club />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/new" element={<AdminNew />} />
          <Route path="/admin/curios" element={<AdminFacts />} />
          <Route path="/admin/curios/workbench" element={<AdminCuriosWorkbench />} />
          <Route path="/admin/trivia" element={<AdminTrivia />} />
          <Route path="/admin/facts" element={<Navigate to="/admin/curios" replace />} />
          <Route path="/admin/edit/:slug" element={<AdminEditFact />} />
          <Route path="/copyright-policy" element={<CopyrightPolicy />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/editorial-standards" element={<EditorialStandards />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
        </VisitorAuthProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
